export const EMPLOYEE_COMPANY_ID = "2";
